<template>
  <div>
    <!-- <h1 class="row col-12 page-title catalog-title text-primary ec-ds-title" v-if="showCatalogDetails">
      {{
        getTranslationFor(
          getCatalog.title,
          locale,
          getCatalog.languages
        )
      }}
    </h1>
    <h1 class="row col-12 page-title" v-else>
      {{ $t("message.header.navigation.data.datasets") }}
    </h1> -->
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  helpers,
} from "@piveau/piveau-hub-ui-modules";
const { getTranslationFor } = helpers;

export default {
  name: "DatasetsTitle",
 data() {
    return {
      useCombinedSearch: this.$env.content.useCombinedSearch
    }
  },
  computed: {
    ...mapGetters("catalogDetails", ["getCatalog"]),
    showCatalogDetails() {
      return this.$route.params.ctlg_id;
    },
    locale() {
      return this.$route.query.locale;
    }
  },
  methods: {
    getTranslationFor
  }
}
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 3rem;
  margin-bottom: 15px;
}
</style>
